<template>
  <iframe-page
    :src="src"
    :surround-image="surroundImage"
    :back-link="backLink"
    title="Collection Expedition"
    @iframe-message="handleMessage"
  >
    <modal-popup
      ref="modal"
    >
      <template v-slot:header>
        <h1>
          Share
        </h1>
      </template>
      <template v-slot:body>
        <img
          v-if="shareImage"
          :src="shareImage"
        >
        <!-- <share-widget
          ref="sharer"
          :url="shareUrl"
          title="Find your Plant Personality | Take the Quiz"
          description="Find your Plant Personality | Take the Quiz"
          @share="handleShare"
        /> -->
      </template>
      <template v-slot:footer />
    </modal-popup>
  </iframe-page>
</template>

<script>
import IframePage from './IframePage'
import ShareWidget from '../components/ShareWidget'
import ModalPopup from '../components/ModalPopup'

export default {
    name: 'BurleMarxGame',
    components: {
        IframePage,
        ModalPopup,
        ShareWidget
    },
    props: {
      surroundImage: {
        type: String,
        default: ''
      },
      backLink: {
        type: [String, Object, Boolean],
        default: false
      }
    },
    data() {
        return {
            src: process.env.BASE_URL + 'frames/collection-expedition/',
            level: 'bottom',
            shareImage: false,
            shareUrl: false,
            lastResult: ''
        }
    },
    methods: {
        handleShare(event) {
          console.log(event)
          this.$gtm.trackEvent({
            category: 'Collection Expedition',
            action: 'Share - ' + event,
            label: this.lastResult
          })
        },
        handleMessage(event) {
            if (event.data.event == 'view-result') {
                this.lastResult = event.data.result
                this.$gtm.trackEvent({
                  category: 'Collection Expedition',
                  action: 'View result',
                  label: event.data.result
                })
            }
            if (event.data.event == 'go-live') {
              this.$router.push({'name': 'burle-marx-live'})
            }
            if (event.data.event == 'share-game') {
              this.shareUrl = event.data.url
              this.shareImage = event.data.image
              this.$refs.modal.open()
            }
        },
        popdownModal() {
          this.$refs.modal.close()
        }
    }
}
</script>